import ClearIcon from "@mui/icons-material/Clear";
import { Rule, useRuleStore } from "csi/middleware/attributeRule/RuleStore";
import IconButton from "designSystem/components/button/IconButton";
import { FlexColumn, FlexRowCenter, OverflowText, SingleSelect } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { ComponentItem } from "designSystem/types/component-item-types";
import _ from "lodash";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import CustomViewFilterLeftColumn from "./CustomViewFilterLeftColumn";
import CustomViewFilterValueSelection from "./CustomViewFilterValueSelection";

interface SingleRuleGridProps {
	/** rule to render as grid */
	rule: Rule;
	/** flag to indicate whether this is just a drag preview */
	isPreview?: boolean;
}

const CustomViewSingleFilterGrid: FunctionComponent<SingleRuleGridProps> = observer(({ isPreview, rule }) => {
	const {
		allConditions,
		options,
		count,
		selectedCondition,
		setSelectedAttribute,
		setSelectedCondition,
		setSelectedOperator,
		removeRule,
	} = useRuleStore();

	const {
		index,
		item,
		operators,
		relativeTypeText,
		selectedOperator,
	} = rule;

	return (
		<FlexColumn 
			data-csi-automation="CustomViewSingleFilterGrid"
			my={3}
		>
			<FlexRowCenter>
				{!isPreview && (
					<CustomViewFilterLeftColumn
						count={count}
						index={index}
						isFlexRow
						onChange={setSelectedCondition}
						options={allConditions}
						value={selectedCondition}
					/>
				)}
				<FlexColumn
					bgcolor={grey[100]}
					border={STANDARD_BORDER_STYLE}
					borderRadius={1}
					p={2}
					pl={4}
					width={1}
				>
					<FlexRowCenter>
						{!_.isEmpty(options) && (
							<SingleSelect
								disableClearable
								forcePopupIcon
								fullWidth
								groupBy={(option) => option.group}
								onChange={(event, value, reason) => setSelectedAttribute(value as ComponentItem, index)}
								options={options}
								value={item}
							/>
						)}
						{!_.isEmpty(operators) && (
							<SingleSelect
								fullWidth
								onChange={(event, newValueItem, reason) => setSelectedOperator(newValueItem, index)}
								options={operators}
								required
								value={selectedOperator}
							/>
						)}
						<CustomViewFilterValueSelection
							filter={rule}
							index={index}
						/>
						<IconButton onClick={() => removeRule(index)} size="medium">
							<ClearIcon />
						</IconButton>
					</FlexRowCenter>
				</FlexColumn>
			</FlexRowCenter>
			{relativeTypeText && (
				<FlexRowCenter pt={1}>
					<OverflowText text={relativeTypeText} />
				</FlexRowCenter>
			)}
		</FlexColumn>
	);
});

export default CustomViewSingleFilterGrid;